//****************************************
// Cursor Legend Prototype
// DOM Registration: No
// National Instruments Copyright 2015
//****************************************

/**
## ni-cursor-legend

> A custom element that provides a cursor legend.

Use it to visualize, add, remove and configure cursors. It can be attached to a graph or chart element.

It provides a list with all the cursors of the graphs and a way to add/remove cursors.

Example:
```html
<ni-cartesian-graph graph-ref="g1" value="[[2, 3, 5, 7, 11, 13, 17, 19],
                          [0, 1, 1, 2, 3, 5, 8, 13]]">
    <ni-cartesian-axis show label="Index" axis-position="bottom"></ni-cartesian-axis>
    <ni-cartesian-axis show label="Value" axis-position="left"></ni-cartesian-axis>
    <ni-cartesian-plot show label="Prime Numbers">
        <ni-cartesian-plot-renderer line-width="2" line-stroke="red">
        </ni-cartesian-plot-renderer>
    </ni-cartesian-plot>
    <ni-cartesian-plot show label="Fibonacci Numbers">
        <ni-cartesian-plot-renderer line-width="2" line-stroke="blue">
        </ni-cartesian-plot-renderer>
    </ni-cartesian-plot>
</ni-cartesian-graph>

<ni-cursor-legend graph-ref="g1" mode="pan"></ni-cursor-legend>
```
*/

(function() {
    'use strict';
    // Static Private Reference Aliases
    var $ = NationalInstruments.Globals.jQuery;
    var NI_SUPPORT = NationalInstruments.HtmlVI.NISupport;
    var niColorValueConverters = window.NIColorValueConverters;

    class CursorLegend extends NationalInstruments.HtmlVI.Elements.GraphLegend {
        /**### ni-cursor-legend properties*/

        /// include ./ni-graph-legend.js

        created() {
            super.created();

            this.table = undefined;
            this.selectedRow = null;
            this.addButton = null;
            this.deleteButton = null;
            this.centerButton = null;
            this.currentRow = null;
            this.currentBtn = null;
            this.observer = null;
            this.helpers = new NationalInstruments.HtmlVI.Elements.CursorLegendHelpers();
            this.cursorLegendItemDisplay = new NationalInstruments.HtmlVI.Elements.CursorLegendItemDisplay(this.helpers);
            this.uihelpers = new NationalInstruments.HtmlVI.Elements.LegendHelpers(this.helpers, this.cursorLegendItemDisplay);
        };

        cursorAdded(cursor) {
            var that = this;
            that.helpers.cursorAdded(cursor);
            that.createRow(that.table, cursor);
            //cursor.label = that.helpers.nextCursorName();
            that.helpers.cursorPositionChanged(cursor, function(data) {
                that.updatePosition(cursor, data);
            });
        };

        updatePosition(cursor, data) {
            if (!cursor._parentGraph) {
                return;
            }

            var cursorIndex = this.helpers.getIndex(cursor),
                xEl = $(this).find('.ni-x-title')[cursorIndex],
                yEl = $(this).find('.ni-y-title')[cursorIndex],
                plot = cursor._parentGraph.graph,
                textValue = plot.formatCursorPosition(plot, cursor.cursor);

            if (xEl !== undefined) {
                xEl.innerText = textValue.xTextValue;
            }

            if (yEl !== undefined) {
                yEl.innerText = textValue.yTextValue;
            }
        };

        // cursor can be removed at runtime or edit time from legend, or at edit time from right rail
        cursorRemoved(cursor) {
            var index = this.helpers.getIndex(cursor);
            if (index >= 0) {
                $(this).find('.ni-master-row').eq(index).remove();
                $(this).find('.ni-details-box').eq(index).remove();
                this.cursorLegendItemDisplay.clearShape(index);
                this.helpers.cursorRemoved(cursor);
            }
        };

        cursorChanged(cursor) {
            this.cursorLegendItemDisplay.updateShape(cursor);
            this.updateName(cursor);
            this.updateVisible(cursor);
            this.updateColor(cursor);
            this.updateTargetShape(cursor);
            this.updateCrosshairStyle(cursor);
        };

        updateName(cursor) {
            var cursorIndex = this.helpers.getIndex(cursor);
            $(this).find('.ni-cursor-title').eq(cursorIndex).text(this.helpers.getState('name', cursor));
        };

        updateVisible(cursor) {
            var visible = this.helpers.getState('visible', cursor);
            var cursorIndex = this.helpers.getIndex(cursor);
            var visibilityButton = $(this).find('.ni-visibility-button').eq(cursorIndex);
            if (visible) {
                visibilityButton.removeClass('ni-visibility-off-icon').addClass('ni-visibility-on-icon');
            } else {
                visibilityButton.removeClass('ni-visibility-on-icon').addClass('ni-visibility-off-icon');
            }
        };

        updateColor(cursor) {
            var cursorIndex = this.helpers.getIndex(cursor);
            var cursorColorRGB = this.helpers.getState('Color', cursor);
            var colorHex = niColorValueConverters.cssRGBAToCssHex(cursorColorRGB);

            var jqxColorPicker = $(this).find('.ni-colorbox-selector').eq(cursorIndex)[0];
            jqxColorPicker.value = colorHex;
        };

        updateTargetShape(cursor) {
            var cursorIndex = this.helpers.getIndex(cursor);
            var targetShapeOptions = this.helpers.targetShapeOptions;
            var index = 0;

            for (let targetShape in targetShapeOptions) {
                if (this.helpers.getState(targetShape, cursor) === true) {
                    var jqxDropDownList = $(this).find('.ni-shape-selector').eq(cursorIndex)[0];
                    jqxDropDownList.selectedIndexes = [index];
                    break;
                }
                index++;
            }
        };

        updateCrosshairStyle(cursor) {
            var cursorIndex = this.helpers.getIndex(cursor);
            var crosshairStyleOptions = this.helpers.crosshairStyleOptions;
            var index = 0;

            for (let crosshairStyle in crosshairStyleOptions) {
                if (this.helpers.getState(crosshairStyle, cursor) === true) {
                    var jqxDropDownList = $(this).find('.ni-crosshair-selector').eq(cursorIndex)[0];
                    jqxDropDownList.selectedIndexes = [index];
                    break;
                }
                index++;
            }
        };

        attachToGraph(graphElement) {
            this.detachFromGraph();
            if (graphElement && graphElement.isReady) {
                this.helpers.graph = graphElement;
                graphElement.registerCursorLegend(this);
            }
        };

        detachFromGraph() {
            this.removeRows();
            this.helpers.clearCache();
            this.helpers.graph = null;
        };

        attached() {
            super.attached();

            var that = this;

            that.helpers.graph = that.findGraph();
            that.helpers.isInEditMode = that.isInEditMode;
            var div = document.createElement('div');
            div.style.width = '100%';
            div.style.height = '100%';
            div.id = 'div' + NI_SUPPORT.uniqueId();
            that.appendChild(div);
            that.table = document.createElement('table');
            that.table.className = 'ni-cursors-box';
            div.appendChild(that.table);

            var buttonsRow = document.createElement('div');
            div.appendChild(buttonsRow);

            var add = this.uihelpers.createJQXButton('ni-add-icon ni-command-button', false);
            add.disabled = that.isDisabledOrInEditMode();

            buttonsRow.appendChild(add);
            that.addButton = add;
            $(add).on('click', function() {
                that.helpers.addCursor();
            });

            that.addEventListener('ni-cursor-attached', function(evt) {
                that.cursorAdded(evt.detail.originalSource);
            });
            that.addEventListener('ni-cursor-detached', function(evt) {
                that.cursorRemoved(evt.detail.originalSource);
            });
            that.addEventListener('ni-cursor-changed', function(evt) {
                that.cursorChanged(evt.detail.originalSource);
            });

            var graph = this.findGraph();

            if (graph !== null) {
                this.attachToGraph(graph);
            }
        };

        removeRows() {
            var i;
            for (i = this.helpers.cursors.length - 1; i >= 0; i--) {
                var cursor = this.helpers.getCursor(i);
                this.cursorRemoved(cursor);
            }
        };

        createRow(table, cursor) {
            var that = this;
            var btn = that.createMainRow(table, cursor);
            var row = that.createDetailsRow(table, cursor);
            $(btn).on('click', function() {
                if (that.currentRow !== row) {
                    var currentRow = that.currentRow;
                    var currentBtn = that.currentBtn;
                    row.style.display = 'table-row';
                    that.currentRow = row;
                    btn.classList.remove('ni-closed-icon');
                    btn.classList.add('ni-open-icon');
                    that.currentBtn = btn;
                    if (currentRow !== null) {
                        currentRow.style.display = 'none';
                    }

                    if (currentBtn !== null) {
                        currentBtn.classList.remove('ni-open-icon');
                        currentBtn.classList.add('ni-closed-icon');
                    }
                } else {
                    row.style.display = 'none';
                    btn.classList.remove('ni-open-icon');
                    btn.classList.add('ni-closed-icon');
                    that.currentRow = null;
                    that.currentBtn = null;
                }
            });
            that.applyFont();
        };

        createMainRow(table, cursor) {
            var that = this;

            var tr, td0, td1, td2, td3, td4, span, p, display, button, showHideButton, visible;
            tr = document.createElement('tr');
            tr.className = 'ni-master-row';
            table.appendChild(tr);

            td0 = document.createElement('td');
            td0.className = 'ni-expand-box';
            tr.appendChild(td0);
            showHideButton = this.uihelpers.createJQXButton('ni-expand-button ni-closed-icon', false);
            td0.appendChild(showHideButton);
            showHideButton.width = 20;
            showHideButton.height = 20;
            showHideButton.disabled = that.isDisabledOrInEditMode();

            td1 = document.createElement('td');
            td1.className = 'ni-cursor-box';
            tr.appendChild(td1);
            display = that.cursorLegendItemDisplay.createHeaderDisplay(cursor);
            if (display !== null) {
                td1.appendChild(display);
            }

            span = document.createElement('span');
            span.className = 'ni-cursor-title';
            p = document.createTextNode(that.helpers.getState('name', cursor));
            span.appendChild(p);
            td1.appendChild(span);

            td2 = document.createElement('td');
            td2.className = 'ni-x-box';
            tr.appendChild(td2);
            span = document.createElement('span');
            span.className = 'ni-x-title';
            p = document.createTextNode(parseFloat(that.helpers.getState('x', cursor)));
            span.appendChild(p);
            td2.appendChild(span);

            td3 = document.createElement('td');
            td3.className = 'ni-y-box';
            tr.appendChild(td3);
            span = document.createElement('span');
            span.className = 'ni-y-title';
            p = document.createTextNode(parseFloat(that.helpers.getState('y', cursor)));
            span.appendChild(p);
            td3.appendChild(span);

            td4 = document.createElement('td');
            td4.className = 'ni-actions-box';
            tr.appendChild(td4);

            button = this.uihelpers.createJQXButton('ni-delete-icon ni-action-button', false);
            td4.appendChild(button);
            $(button).on('click', function() {
                that.helpers.handleClick('delete', '', cursor);
            });
            button.disabled = that.isDisabledOrInEditMode();

            button = this.uihelpers.createJQXButton('ni-center-icon ni-action-button', false);
            td4.appendChild(button);
            $(button).on('click', function() {
                that.helpers.handleClick('center', '', cursor);
            });
            button.disabled = that.isDisabledOrInEditMode();

            button = this.uihelpers.createJQXButton('ni-snap-icon ni-action-button', true);
            td4.appendChild(button);
            $(button).on('click', function() {
                that.helpers.handleClick('snap', '', cursor);
            });
            button.disabled = that.isDisabledOrInEditMode();

            button = this.uihelpers.createJQXButton('ni-visibility-button ni-action-button', true);
            visible = that.helpers.getState('visible', cursor);
            if (visible) {
                button.classList.add('ni-visibility-on-icon');
            } else {
                button.classList.add('ni-visibility-off-icon');
            }

            $(button).on('click', function() {
                that.helpers.handleClick('visible', '', cursor);
            });

            td4.appendChild(button);
            button.disabled = that.isDisabledOrInEditMode();

            return showHideButton;
        };

        createDetailsItem(table, title) {
            var tr, td1, td2, span, p;
            tr = document.createElement('tr');
            tr.className = 'ni-details-row';
            table.appendChild(tr);

            td1 = document.createElement('td');
            td1.className = 'ni-details-row-title-box';
            tr.appendChild(td1);
            span = document.createElement('span');
            span.class = 'ni-details-row-title';
            td1.appendChild(span);
            p = document.createTextNode(title);
            span.appendChild(p);

            td2 = document.createElement('td');
            td2.className = 'ni-details-row-control-box';
            tr.appendChild(td2);
            return td2;
        };

        createDetailsRow(table, cursor) {
            var subtable, tr, td, dropdownContainer;

            tr = document.createElement('tr');
            tr.className = 'ni-details-box';
            tr.style.display = 'none';
            table.appendChild(tr);

            td = document.createElement('td');
            td.colSpan = 5;
            tr.appendChild(td);

            subtable = document.createElement('table');
            subtable.className = 'ni-details';
            td.appendChild(subtable);

            dropdownContainer = this.createDetailsItem(subtable, 'Color');
            this.uihelpers.addColorBox({
                name: 'Color'
            }, dropdownContainer, cursor, 'ni-colorbox-selector ni-selector');

            dropdownContainer = this.createDetailsItem(subtable, 'Shape');
            this.uihelpers.addComboBox(this.helpers.getMenuItem('shape'), dropdownContainer, cursor, 16, 'ni-shape-selector ni-selector');

            dropdownContainer = this.createDetailsItem(subtable, 'Crosshair');
            this.uihelpers.addComboBox(this.helpers.getMenuItem('crosshair'), dropdownContainer, cursor, 16, 'ni-crosshair-selector ni-selector');

            return tr;
        };

        setFont(fontSize, fontFamily, fontWeight, fontStyle, textDecoration) {
            var childElement = this.firstElementChild,
                thisRef = $(this),
                jqrefContent = $('#' + childElement.id + ' .jqx-widget-content'),
                jqrefItemName = $('#' + childElement.id + ' .ni-cursor-title'),
                jqrefItemX = $('#' + childElement.id + ' .ni-x-title'),
                jqrefItemY = $('#' + childElement.id + ' .ni-y-title'),
                jqrefItemDetails = $('#' + childElement.id + ' .ni-details-title');

            thisRef.css({
                'font-size': fontSize,
                'font-family': fontFamily,
                'font-weight': fontWeight,
                'font-style': fontStyle
            });

            jqrefContent.css({
                'font-size': fontSize,
                'font-family': fontFamily,
                'font-weight': fontWeight,
                'font-style': fontStyle
            });
            jqrefItemName.css({
                'font-size': fontSize,
                'font-family': fontFamily,
                'font-weight': fontWeight,
                'font-style': fontStyle
            });
            jqrefItemX.css({
                'font-size': fontSize,
                'font-family': fontFamily,
                'font-weight': fontWeight,
                'font-style': fontStyle
            });
            jqrefItemY.css({
                'font-size': fontSize,
                'font-family': fontFamily,
                'font-weight': fontWeight,
                'font-style': fontStyle
            });
            jqrefItemDetails.css({
                'font-size': fontSize,
                'font-family': fontFamily,
                'font-weight': fontWeight,
                'font-style': fontStyle
            });
        };

        applyFont() {
            var childElement = this.firstElementChild,
                jqrefContent = $('#' + childElement.id + ' .jqx-widget-content'),
                jqrefItemName = $('#' + childElement.id + ' .ni-cursor-title'),
                jqrefItemX = $('#' + childElement.id + ' .ni-x-title'),
                jqrefItemY = $('#' + childElement.id + ' .ni-y-title'),
                jqrefItemDetails = $('#' + childElement.id + ' .ni-details-title');

            var fontSize = $(this).css('font-size');
            var fontFamily = $(this).css('font-family');
            var fontWeight = $(this).css('font-weight');
            var fontStyle = $(this).css('font-style');
            jqrefContent.css({
                'font-size': fontSize,
                'font-family': fontFamily,
                'font-weight': fontWeight,
                'font-style': fontStyle
            });
            jqrefItemName.css({
                'font-size': fontSize,
                'font-family': fontFamily,
                'font-weight': fontWeight,
                'font-style': fontStyle
            });
            jqrefItemX.css({
                'font-size': fontSize,
                'font-family': fontFamily,
                'font-weight': fontWeight,
                'font-style': fontStyle
            });
            jqrefItemY.css({
                'font-size': fontSize,
                'font-family': fontFamily,
                'font-weight': fontWeight,
                'font-style': fontStyle
            });
            jqrefItemDetails.css({
                'font-size': fontSize,
                'font-family': fontFamily,
                'font-weight': fontWeight,
                'font-style': fontStyle
            });
        };

        propertyChangedHandler(propertyName, oldValue, newValue) {
            var that = this;

            super.propertyChangedHandler(propertyName, oldValue, newValue);

            switch (propertyName) {
                case 'graphRef':
                    // TODO: add a cursor-legend-detached event for parent graph
                    this.helpers.graph.cursorLegend = null;
                    var graphElement = this.findGraph();
                    this.attachToGraph(graphElement);
                    break;
                case 'disabled':
                case 'isInEditMode':
                    // this changes once after the element is created
                    this.helpers.isInEditMode = this.isInEditMode;

                    if (this.addButton !== null) {
                        this.addButton.disabled = this.isDisabledOrInEditMode();
                    }

                    $(this.table).find('.ni-center-icon').each(function() {
                        this.disabled = that.isDisabledOrInEditMode();
                    });

                    $(this.table).find('.ni-expand-button').each(function() {
                        this.disabled = that.isDisabledOrInEditMode();
                    });

                    $(this.table).find('.ni-snap-icon').each(function() {
                        this.disabled = that.isDisabledOrInEditMode();
                    });

                    $(this.table).find('.ni-delete-icon').each(function() {
                        this.disabled = that.isDisabledOrInEditMode();
                    });

                    $(this.table).find('.ni-visibility-button').each(function() {
                        this.disabled = that.isDisabledOrInEditMode();
                    });

                    $(this.table).find('.ni-colorbox-selector').each(function() {
                        this.disabled = that.isDisabledOrInEditMode();
                    });

                    $(this.table).find('.ni-shape-selector').each(function() {
                        this.disabled = that.isDisabledOrInEditMode();
                    });

                    $(this.table).find('.ni-crosshair-selector').each(function() {
                        this.disabled = that.isDisabledOrInEditMode();
                    });
                    break;
                default:
                    break;
            }
        };
    };

    JQX('ni-cursor-legend', CursorLegend);
}());
